module.exports = __webpack_public_path__ + "img/patchy_the_pirate.89edf768.jpg";